import React, {useEffect} from 'react'
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { connect } from "react-redux";
import { Card, CardBody, CardTitle } from "reactstrap";


// components
import LangFilters from "./_filters";
import LangForm from "./_form";
import { ModalFormContainer } from "../../../components/confirmAlert/ModalFormContainer";
import { GenericTableButton } from "../../../components/buttons/buttonsActions";
import { ConfirmDelete } from "../../../components/confirmAlert/ConfirmDelete";
import { ActiveFormatter}  from "../../../components/tables/activeFormater";

// labels
import {
    LIST,
    NO_DATA_FOUND,
} from "../../../components/i18n/i18n";
import {TT_DELETE, TT_EDIT} from "../../../components/i18n/toolTips";

// actions
import { setFilter, setTableParams } from "../../../redux/actions/generalActions/listActions";
import { setViewMode } from "../../../redux/actions/generalActions/mainActions";
import { remove } from "../../../redux/actions/comunication/notificationActions";
import { setForm, setItem } from "../../../redux/actions/generalActions/formActions";
import { genericActions } from "../../../redux/actions/generics/GenericActions";
import {langService} from "../../../jwt/_services";
import LangFormatter from "../../../components/tables/langFormatter";

// services


const LangList = props => {
    const { app } = props.mainProps
    const { pageSize, pageIndex, totalSize, listDomainObjects, filter } = props.listProps

    useEffect( () => {
        if (!props.generalPropouse) {
            if (!app?.fbDataBase?.id)
                return;

            const _filter = {
                onlyRegistered : true,
                fbDataBase : { id : app?.fbDataBase?.id },
                item : {
                    status : null,
                    translateBase : null,
                    enabledToEdit : null,
                    toPreload : null,
                    saveHisTranslation : null,
                }
            };

            props.setFilter(_filter);
        } else {
            const _filter = {
                onlyRegistered : false,
                item : {
                    status : null,
                    translateBase : null,
                    enabledToEdit : null,
                    toPreload : null,
                    saveHisTranslation : null,
                }
            };

            props.setFilter(_filter);
        }
    }, [ app ]);

    // realizar búsqueda cuando cambie el filtro
    useEffect(() => {
        if(!filter)
            return

        genericActions.search(langService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter ]);

    const handleTableChange = (type, tableChangeParams) => {
        let currentIndex = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        props.setTableParams( tableChangeParams.sizePerPage, currentIndex );
    };

    const confirmDelete = (data) => {
        return ConfirmDelete({ remove : genericActions.remove , data : data, fbDataBaseId : app?.fbDataBase?.id, service: langService } );
    };

    const editItem = (data) => {
        props.setForm(true, false, false);
        props.setItem(data);
        ModalFormContainer(LangForm, { data, Form: LangForm, generalPropouse : props.generalPropouse })
    }


    const actionsFormatter = (cell, row) => <>
        <GenericTableButton toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
        <GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
    </>

    const langFormatter = (cell, row )=> <LangFormatter langCode={row.twoLetterCode} nativeName={row.nativeName} />

    const activeFormatter = cell => <ActiveFormatter active={cell} />

    const columns = [{
        dataField: 'id',
        headerStyle: {width: '0px'},
        text: 'ID',
        hidden: true
    }, {
        dataField: 'uid',
        text: 'Uid',
        headerStyle: {width: '200px'},
    }, {
        dataField: 'name',
        text: 'Nombre',
    }, {
        dataField: 'nativeName',
        text: 'Nombre nativo',
    }, {
        dataField: 'twoLetterCode',
        text: 'Codigo [2]',
        headerStyle: {width: '100px'},
    }, {
        dataField: 'threeLetterCode',
        text: "Codigo [3]",
        headerStyle: {width: '100px'},
    }, {
        isDummyField: true,
        text: "Bandera",
        headerAlign: 'center',
        align: 'center',
        headerStyle: {width: '80px'},
        formatter: langFormatter
    }, {
        dataField: 'status',
        text: "Activo",
        headerAlign: 'center',
        align: 'center',
        headerStyle: {width: '80px'},
        formatter: activeFormatter
    }, {
        dataField: 'isDefault',
        text: "Defecto",
        headerAlign: 'center',
        align: 'center',
        headerStyle: {width: '80px'},
        formatter: activeFormatter
    }, {
        dataField: 'actions',
        isDummyField: true,
        text: 'Acción',
        headerAlign: 'center',
        align: 'center',
        headerStyle: {width: '150px'},
        formatter: actionsFormatter
    }
    ];

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"> </i>{LIST}
        </CardTitle>

        <LangFilters generalPropouse={props.generalPropouse} />

        <CardBody className="">
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || []}
                columns={columns}
                noDataIndication={NO_DATA_FOUND}
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={handleTableChange}
            />
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({
    mainProps : state.mainProps,
    listProps : state.listProps,
})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
    remove,
})

export default connect(mapStateToProps, mapActionsToProps)(LangList)